import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import { Link } from 'react-router';

import * as genericHelper from 'src/app-lib/helpers/genericHelper';
import { Placeholder } from './../loading-state/placeholder';

export class ContentChannelDetail extends React.Component {
    constructor(props) {
        super(props);
    }

    displayChannelLogo() {
        const { channelLogo } = this.props;
        return (
            <span>
            {channelLogo ? <img className="content-channel-detail__channel-logo" alt="" src={channelLogo} /> : null}
            </span>
        );
    }

    displayChannelTitle() {
        return (
            <div className="content-channel-detail__channel-title" title={this.props.channelTitle}>{this.props.channelTitle}</div>
        );
    }

    displayContentTitle() {
        return (
            <div className="content-channel-detail__content-title" title={this.props.contentTitle}>{this.props.contentTitle}</div>
        );
    }

    displayContentDesc() {
        return (
            <div className="content-channel-detail__content-desc" title={this.props.contentDescription}>{this.props.contentDescription}</div>
        );
    }

    displayContentCategory() {
        return (
          this.props.contentCategory &&
              <div className="content-channel-detail__content-category" title={i18n.t(`categories.${this.props.contentCategory}`)}>
              {i18n.t(`categories.${this.props.contentCategory}`)}
              </div>
        );
    }

    displayContentTimeline() {
        return (
            <div className="content-channel-detail__timeline">
            {genericHelper.timeSinceToday(this.props.contentPublishDate)}
            </div>
        );
    }

    displayChannelInfo() {
        const { isFetching } = this.props;
        return (
            <div className="content-channel-detail__channel-info" onClick={this.props.channelInfoClickHandler.bind(this)} >
            {isFetching ? <Placeholder height={'23px'} width={'23px'} borderRadius={'3px'} margin={'3px 5px 3px 3px'} float={'left'} /> : this.displayChannelLogo()}
            {isFetching ? <Placeholder height={'10px'} width={'50%'} borderRadius={'3px'} margin={'8px 10px 8px 10px'} float={'left'} /> : this.displayChannelTitle()}
            </div>
        );
    }


    render() {
        const { isFetching, channelKey } = this.props;
        return (
            <div className="content-channel-detail">
              {channelKey ? <Link to={`/channel/${channelKey}`}>{this.displayChannelInfo()}</Link> : this.displayChannelInfo()}
                {isFetching ? <Placeholder height={'10px'} width={'90%'} borderRadius={'3px'} margin={'16px 5px 10px -27px'} float={'left'} /> : this.displayContentTitle()}
                {isFetching ?
                    <div>
                        <Placeholder height={'8px'} width={'70%'} borderRadius={'3px'} margin={'8px 43px 5px 4px'} float={'left'} />
                        <Placeholder height={'8px'} width={'50%'} borderRadius={'3px'} margin={'8px 65px 12px 4px'} float={'left'} />
                    </div>
                  : this.displayContentDesc()}
                {isFetching ? <Placeholder height={'10px'} width={'40%'} borderRadius={'3px'} margin={'20px 8px 2px 4px'} float={'left'} /> : this.displayContentCategory()}
                {isFetching ? <Placeholder height={'10px'} width={'30%'} borderRadius={'3px'} margin={'20px 2px 2px 20px'} float={'left'} /> : this.displayContentTimeline()}
            </div>
      );
    }
}

ContentChannelDetail.propTypes = {
    channelKey: PropTypes.string.isRequired,
    channelTitle: PropTypes.string.isRequired,
    channelLogo: PropTypes.string,
    contentTitle: PropTypes.string.isRequired,
    contentDescription: PropTypes.string,
    contentCategory: PropTypes.string,
    contentPublishDate: PropTypes.number,
    isFetching: PropTypes.number,
    channelInfoClickHandler: PropTypes.func
};



// WEBPACK FOOTER //
// ./src/components/SharedComponents/content/content-channel-detail.js